import AddIn from "@mui/icons-material/Add";
import AddBoxIcon from "@mui/icons-material/AddBox";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { flushSync } from "react-dom";
import { useTranslation } from "react-i18next";
import { generateTranslateMuiTable } from "../../../utils/Function/commonFunction";
import {
  CustomDialog,
  StyledDataGrid,
} from "../../../components/StyledComponents";
import { useLoading } from "../../../context/LoadingContext";
import NoRowOverlay from "../../../assets/images/icons/NoRowOverlay";
import CustomPagination from "../CustomPagination";
import CustomGridToolbarQuickFilterNew from "../CustomGridToolbarQuickFilterNew";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ConfirmInvitationDialog from "./ConfirmInvitationDialog";
import ConfirmRemoveInvationDialog from "./ConfirmRemoveInvationDialog";
import {
  ControlpanelPrimaryButton,
  GrayIconButton,
} from "../../../components/StyledButton";
import SendIcon from "@mui/icons-material/Send";
import InviteNewUserDialog from "./InviteNewUserDialog";
import { getinviteEmail, inviteEmail } from "../../../axios/Invitation/InvitationApi";
import { toast } from "react-toastify";
import { useGetGeneralPolicyUserRole } from "../../../hooks/useGeneralService";
import { deleteInvitations, checkValid } from "../../../axios/Account/AccountApi";
import { isAxiosError } from "axios";
import ReplayIcon from '@mui/icons-material/Replay';
import CustomColumnsPanel from "../../../components/CustomColumnsPanel";

const InviteEmployeesDialogNew = ({ defaultValue, onClose }) => {
  const [show, hide] = useLoading();
  const { t } = useTranslation();
  const { data: userRoles } = useGetGeneralPolicyUserRole();

  const [listEmail, setListEmail] = useState([]);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });
  const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);

  const hasActiveSearch = useMemo(
    () =>
      (filterModel.quickFilterValues || []).some(
        (value) => String(value ?? "").trim().length > 0
      ),
    [filterModel.quickFilterValues]
  );

  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [confirmInvationOpen, setConfirmInvationOpen] = useState(false);
  const [confirmRemoveInvationOpen, setConfirmRemoveInvationOpen] =
    useState(false);
  const [inviteNewUserOpen, setInviteNewUserOpen] = useState(false);

  const roleLabelMap = {
    EMPLOYEE: t("roles2.Employee"),
    AUDITOR: t("roles2.Auditor"),
    ADMIN: t("roles2.Admin"),
    SUBCRIPTION: t("roles2.SubscriptionAdmin"),
  };

  const getStateStyle = (state) => {
    switch (state) {
      case 1:
        return { label: t("common.pending"), color: "#EAB308" }; // yellow-500
      case 2:
        return { label: t("common.approved"), color: "#16A34A" }; // green-600
      case 3:
        return { label: t("common.rejected"), color: "#DC2626" }; // red-600
      default:
        return { label: "-", color: "#6B7280" }; // gray-500
    }
  };

  const filteredListEmail = useMemo(
    () =>
      Array.isArray(listEmail)
        ? listEmail.filter((item) => item.state !== 2) // ❌ bỏ state = 1
        : [],
    [listEmail]
  );

  useEffect(() => {
    if (userRoles && userRoles.length > 0) {
      const employee = userRoles.find(r => r.roleName === "EMPLOYEE") || userRoles[0];
    }
  }, [userRoles]);

  const getRoleLabelByPermissionId = (permissionId) => {
    if (!userRoles || userRoles.length === 0) return "";
    const found = userRoles.find(r => r.userRoleId === permissionId); // <-- so sánh đúng key
    if (!found) return "";
    return roleLabelMap[found.roleName] ?? found.roleName;
  };

  const handleCloseDialog = () => onClose?.();

  // const handleRemoveEmail = (rowId) => {
  //   setListEmail((prev) => prev.filter((_, idx) => idx !== rowId));
  // };

  const handleOpenConfirmInvation = (rowId, row) => {
    setSelectedRowId(rowId);
    setSelectedRow(row);
    setConfirmInvationOpen(true);
  };
  const handleCloseConfirmInvation = () => {
    setConfirmInvationOpen(false);
    setSelectedRowId(null);
    setSelectedRow(null);
  };

  const handleOpenConfirmRemoveInvation = (rowId, row) => {
    setSelectedRowId(rowId);
    setSelectedRow(row);
    setConfirmRemoveInvationOpen(true);
  };
  const handleCloseConfirmRemoveInvation = () => {
    setConfirmRemoveInvationOpen(false);
    setSelectedRowId(null);
    setSelectedRow(null);
  };

  const handleOpenInviteNewUser = (rowId, row) => {
    setInviteNewUserOpen(true);
  };
  const handleCloseInviteNewUser = () => {
    setInviteNewUserOpen(false);
  };

  // Tour: mở/đóng InviteNewUserDialog
  useEffect(() => {
    window.__openInviteNewUserDialog = () => {
      flushSync(() => setInviteNewUserOpen(true));
    };
    window.__closeInviteNewUserDialog = () => {
      flushSync(() => setInviteNewUserOpen(false));
    };
    return () => {
      delete window.__openInviteNewUserDialog;
      delete window.__closeInviteNewUserDialog;
    };
  }, []);

  const fetchDataInvations = async () => {
    try {
      const response = await getinviteEmail({
        langId: localStorage.getItem("i18nextLngId"),
      });
      setListEmail(response.data.data);
    } catch (error) {

      if (error?.response?.status !== 401) {
        toast.error(t(error?.response?.data));
      }
      else {
        toast.error(t('common.network-timeout'));
      }
    }
  };


  useEffect(() => {

    fetchDataInvations();
  }, []);

  const handleRemoveEmail = async (inviteId) => {
    // lưu lại state cũ để rollback nếu lỗi
    const prev = listEmail;
    // optimistic update
    setListEmail((cur) => cur.filter((it) => String(it.id) !== String(inviteId)));

    const payload = { inviteId: String(inviteId) };

    try {
      const res = await deleteInvitations(payload);
      const ok =
        (res && res.status >= 200 && res.status < 300) ||
        res?.data === '' ||
        res?.data?.responseCode === 0;

      if (ok) {
        toast.success(t('common.delete-invitation-successfully'));
        fetchDataInvations();
      } else {
        setListEmail(prev);
        toast.error(res?.data?.message || t('common.error'));
      }
    } catch (error) {
      // rollback khi lỗi
      setListEmail(prev);

      if (error?.response && error.response.status !== 401) {
        // nếu BE trả key i18n dạng string
        toast.error(t(error.response.data) || t('common.error'));
      } else {
        toast.error(t('common.network-timeout'));
      }
    }
  };

  const handleResendInvitation = async () => {
    if (!selectedRow) return;

    const citizenNumber = selectedRow.citizenIdentificationNumber;
    const email = selectedRow.email;
    const langId = localStorage.getItem("i18nextLngId");

    try {
      show();

      // Chỉ resend khi check-valid thành công
      const validRes = await checkValid(citizenNumber, email, langId);
      if (!(validRes?.data?.responseCode === 0)) {
        toast.error(validRes?.data?.message || t("common.error"));
        return;
      }

      const payload = [
        {
          citizenNumber,
          email,
          permissionId: selectedRow.permissionId,
        },
      ];

      const res = await inviteEmail(payload);

      if (res?.data?.message === "Successful" || res?.data?.message === "Thành công") {
        toast.success(t("common.resend-invitation-successfully"));
        fetchDataInvations();
      } else {
        toast.error(res?.data?.message || t("common.error"));
      }
    } catch (error) {
      if (isAxiosError(error)) {
        const rawData = error.response && error.response.data;
        let code;
        let msg;

        // 🔹 TH 1: server trả string kiểu "400 Bad Request: "{...}""
        if (typeof rawData === "string") {
          try {
            const start = rawData.indexOf("{");
            const end = rawData.lastIndexOf("}");

            if (start !== -1 && end !== -1 && end > start) {
              const jsonStr = rawData.substring(start, end + 1);
              const parsed = JSON.parse(jsonStr);

              code = parsed.responseCode;
              msg = parsed.message;
            }
          } catch (e) {
            // parse lỗi thì kệ, xuống fallback
          }
        }

        // 🔹 TH 2: server trả object JSON bình thường
        if (!code && rawData && typeof rawData === "object") {
          code = rawData.responseCode;
          msg = rawData.message;
        }

        // Nếu đã lấy được responseCode từ body
        if (code) {
          if (code === 1049) {
            toast.error(msg || "Không tìm thấy tài khoản");
          } else {
            toast.error(msg || t("common.error"));
          }
          return;
        }

        // Không có responseCode nhưng là 500 -> lỗi server
        if (error.response && error.response.status === 500) {
          toast.error(t("ERRORMSG_1066"));
          return;
        }

        // Fallback chung
        const fallback =
          (typeof rawData === "string" ? rawData : "") ||
          (rawData && rawData.error) ||
          error.message;

        toast.error(fallback || t("common.error"));
      } else {
        toast.error(t("common.error"));
      }
    } finally {
      hide();
      handleCloseConfirmInvation();
    }
  };

  const columnData = useMemo(
    () => [
      {
        field: "citizenIdentificationNumber",
        headerName: t("common.personal-id"),
        flex: 1,
        minWidth: 150,
      },
      {
        field: "email",
        headerName: t("common.email"),
        flex: 1.2,
        minWidth: 220,
      },
      {
        field: "permissionId",
        headerName: t("common.administrator-rights"),
        flex: 1,
        minWidth: 180,
        renderCell: ({ value }) => getRoleLabelByPermissionId(value)
      },
      {
        field: "state",
        headerName: t("common.status"),
        width: 150,
        renderCell: ({ row }) => {
          // createdAt có thể là "2025-11-26 10:20:30" hoặc ISO
          let isExpired = false;
          if (row.state === 1 && row.createdAt) {
            // đảm bảo Date parse được
            const created = new Date(
              String(row.createdAt).replace(" ", "T") // "2025-11-26 10:20:30" -> "2025-11-26T10:20:30"
            );
            if (!isNaN(created.getTime())) {
              const diffMs = Date.now() - created.getTime();
              const oneDayMs = 24 * 60 * 60 * 1000;
              isExpired = diffMs > oneDayMs;
            }
          }

          let color = "#6B7280";
          let label = "-";

          if (row.state === 1 && isExpired) {
            // ✅ Approved nhưng quá 1 ngày -> Hết hạn
            color = "#9CA3AF"; // xám
            label = t("common.expired") || "Hết hạn";
          } else {
            const colorMap = {
              1: "#FFCC00", // pending (nhưng đã bị filter nên không còn)
              2: "#34C759", // approved còn hiệu lực
              3: "#FF3B30", // rejected
            };

            const labelMap = {
              1: t("common.pending"),
              2: t("common.approved"),
              3: t("common.rejected"),
            };

            color = colorMap[row.state] || "#6B7280";
            label = labelMap[row.state] || "-";
          }

          return (
            <span style={{ color, fontWeight: 600 }}>
              {label}
            </span>
          );
        },
      },
      {
        field: "options",
        headerName: t("common.options"),
        sortable: false,
        filterable: false,
        width: 120,
        renderCell: (params) => {
          const isPending = params.row.state === 2; // state = 1 thì ẩn edit

          return (
            <div className="flex gap-2 items-center">
              {/* chỉ render nút edit khi state !== 1 */}
              {!isPending && (
                <div>
                  <Tooltip
                    title={
                      <div>
                        <div>{t('button.resend-email')}</div>
                      </div>
                    }
                    placement="bottom"
                    arrow
                  ><IconButton
                    aria-label="edit"
                    sx={{
                      backgroundColor: "#E5E7EB",
                      width: 30,
                      height: 30,
                      "&:hover": { backgroundColor: "#d6d8db" },
                    }}
                    onClick={() =>
                      handleOpenConfirmInvation(params.id, params.row)
                    }
                  >
                      <ReplayIcon sx={{ color: "#3B82F6", fontSize: 14 }} />
                    </IconButton></Tooltip>
                </div>
              )}

              <div>
                <Tooltip
                  title={
                    <div>
                      <div>{t('button.delete')}</div>
                    </div>
                  }
                  placement="bottom"
                  arrow
                ><IconButton
                  aria-label="delete"
                  sx={{
                    backgroundColor: "#E5E7EB",
                    width: 30,
                    height: 30,
                    "&:hover": { backgroundColor: "#d6d8db" },
                  }}
                  onClick={() =>
                    handleOpenConfirmRemoveInvation(params.id, params.row)
                  }
                >
                    <DeleteIcon sx={{ color: "#DC2626", fontSize: 14 }} />
                  </IconButton></Tooltip>
              </div>
            </div>
          );
        },
      }

    ],
    [t]
  );

  const templateToolbar = useCallback(
    () => (
      <div className="flex items-center pb-5 pt-5 w-full justify-between">
        <div className="flex gap-3 w-full ">
          <CustomGridToolbarQuickFilterNew />
          <ControlpanelPrimaryButton
            className="h-10"
            data-tour="user-management-invite-new-user-button"
            onClick={() => handleOpenInviteNewUser()}
          >
            <SendIcon />
            <p>{t("button.invite-new-user")}</p>
          </ControlpanelPrimaryButton>
        </div>
      </div>
    ),
    [t, listEmail.length]
  );

  const handleRowsPerPageChange = (newPageSize) => {
    // newPageSize ở đây tuỳ CustomPagination, có thể là event hoặc number
    const size =
      typeof newPageSize === "number"
        ? newPageSize
        : parseInt(newPageSize.target.value, 10);

    setPage((prevPage) => {
      // index của record đầu tiên đang xem
      const firstRowIndex = prevPage * pageSize;

      // page mới sao cho vẫn chứa record đó
      const newPage = Math.floor(firstRowIndex / size);

      // phòng trường hợp vượt quá số trang
      const maxPage = Math.max(
        0,
        Math.ceil(listEmail.length / size) - 1
      );

      return Math.min(newPage, maxPage);
    });

    setPageSize(size);
  };

  const gridRows = useMemo(
    () =>
      filteredListEmail.map((item, idx) => ({
        id: item.id,
        index: idx + 1,
        citizenIdentificationNumber: item.citizenIdentificationNumber,
        email: item.email,
        permissionId: item.permissionId,
        state: item.state,
        createdAt: item.createdAt,
      })),
    [filteredListEmail]
  );

  // Khi chưa search: hiện NoRowOverlay; khi đang search không ra kết quả: hiện text mặc định
  const NoResultsOverlay = useCallback(() => {
    if (!hasActiveSearch) {
      return <NoRowOverlay />;
    }
    return (
      <div className="flex items-center justify-center h-full w-full">
        <p>{t("common.no-result-found")}</p>
      </div>
    );
  }, [hasActiveSearch, t]);

  return (
    <>
      <CustomDialog
        open
        keepMounted
        sx={{ ".MuiPaper-root": { width: "800px" } }}
        maxWidth={"xl"}
        onClose={handleCloseDialog}
        transitionDuration={window.__tourIsOpen ? 0 : undefined}
        data-tour="user-management-invite-dialog"
      >
        <DialogTitle>
          <div className="flex justify-between">
            <div className="flex items-center gap-4">
              <p className="text-xl font-semibold ">{t("button.invitation")}</p>
            </div>
            <GrayIconButton onClick={handleCloseDialog} className="self-start">
              <CloseIcon />
            </GrayIconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <div data-tour="user-management-invite-table">
          <StyledDataGrid
            showColumnVerticalBorder
            sx={{
              height: 400,
              ".MuiDataGrid-main": { height: "70vh" },
              "& .MuiDataGrid-scrollbar--vertical, & .MuiDataGrid-scrollbar--horizontal":
                { display: "none !important" },
              "& .MuiDataGrid-scrollbarFiller": { display: "none !important" },
              "& .MuiDataGrid-columnHeaders": { paddingRight: 0 },
              "& .MuiDataGrid-topContainer": { paddingRight: 0 },
              "&": { "--DataGrid-scrollbarSize": "0px" },
              "& .MuiDataGrid-virtualScroller": { scrollbarWidth: "none" },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                width: 0,
                height: 0,
              },
              "&:hover .MuiDataGrid-virtualScroller, &:focus-within .MuiDataGrid-virtualScroller":
                { scrollbarWidth: "thin" },
              "&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar, &:focus-within .MuiDataGrid-virtualScroller::-webkit-scrollbar":
              {
                width: 10,
                height: 10,
              },
              '& [class*="MuiDataGrid-scrollbar"][class*="--horizontal"]': {
                display: "none !important",
              },
            }}
            rows={gridRows}
            getRowId={(r) => r.id}
            columns={columnData}
            rowCount={filteredListEmail.length}
            filterModel={filterModel}
            onFilterModelChange={setFilterModel}
            slots={{
              toolbar: templateToolbar,
              pagination: CustomPagination,
              noRowsOverlay: NoRowOverlay,
              noResultsOverlay: NoResultsOverlay,
              columnsPanel: CustomColumnsPanel,
            }}
            slotProps={{
              pagination: {
                page,
                count: filteredListEmail.length,
                rowsPerPage: pageSize,
                onPageChange: setPage,
                onRowsPerPageChange: handleRowsPerPageChange,
              },
            }}
            localeText={tableTranslated}
            disableRowSelectionOnClick
          />
          </div>
        </DialogContent>
      </CustomDialog>

      <ConfirmInvitationDialog
        open={confirmInvationOpen}
        onClose={handleCloseConfirmInvation}
        onConfirm={handleResendInvitation}
        data={selectedRow}
      />


      <ConfirmRemoveInvationDialog
        open={confirmRemoveInvationOpen}
        onClose={handleCloseConfirmRemoveInvation}
        rowId={selectedRowId}
        row={selectedRow}
        onConfirm={() => {
          if (selectedRowId != null) {
            handleRemoveEmail(selectedRowId);
          }
          handleCloseConfirmRemoveInvation();
        }}
      />

      {inviteNewUserOpen && (
        <InviteNewUserDialog
          onClose={handleCloseInviteNewUser}
          onSuccess={fetchDataInvations}
        />
      )}
    </>
  );
};

export default InviteEmployeesDialogNew;